// Textes de la page des alertes
export const ALERTS_TEXTS = {
  title: 'Alertes',
  addAlert: 'Ajouter une alerte',
  name: 'Nom',
  enabled: 'Activé',
  condition: 'Condition',
  conditions: 'Conditions',
  noCondition: 'Aucune condition',
  repeat: 'Répéter',
  delayedNotification: 'Notification différée',
  notifications: 'Notifications',
  recipientsTooltipEmpty: 'Aucun destinataire',
  emailNotificationsDisabled: 'Notifications email désactivées',
  smsNotificationsDisabled: 'Notifications SMS désactivées',
  sensorCount: 'Capteurs',
  loading: 'Chargement des alertes...',
  errorLoading: 'Erreur lors du chargement des alertes',
  noAlerts: 'Aucune alerte trouvée',
  searchPlaceholder: 'Rechercher des alertes...',
  selectFilters: 'Sélectionner des filtres',
  selectOrgMessage: 'Veuillez sélectionner des filtres pour voir les alertes',
  selectOrgDescription: 'Utilisez le panneau de filtres ci-dessus pour sélectionner une organisation.',
  filterByOrganization: 'Filtrer par organisation',
  selectOrganization: 'Sélectionner une organisation',
  allOrganizations: 'Toutes les organisations',
  yes: 'Oui',
  no: 'Non',
  
  // Étapes du formulaire d'alerte
  steps: {
    basicInformation: 'Informations de base',
    alertConditions: 'Conditions d\'alerte',
    selectSensors: 'Sélectionner les capteurs',
    notifications: 'Notifications',
    settings: 'Paramètres',
    review: 'Révision'
  },
  
  // Descriptions des étapes
  stepDescriptions: {
    basicInformation: 'Définir l\'organisation, le nom et le statut de l\'alerte',
    alertConditions: 'Configurer quand l\'alerte doit se déclencher',
    selectSensors: 'Choisir les capteurs à surveiller',
    notifications: 'Configurer les notifications par email et SMS',
    settings: 'Configurer les paramètres de répétition et de délai',
    review: 'Réviser et confirmer la configuration de votre alerte'
  },
  
  // Sections du formulaire
  form: {
    organizationBasicInfo: 'Organisation et informations de base',
    selectOrganizationDescription: 'Sélectionner l\'organisation et configurer les paramètres de base de l\'alerte',
    alertConditionsTitle: 'Conditions d\'alerte',
    alertConditionsDescription: 'Définir quand cette alerte doit être déclenchée selon les données des capteurs',
    selectSensorsTitle: 'Sélectionner les capteurs',
    selectSensorsDescription: 'Choisir les capteurs que cette alerte doit surveiller',
    notificationSettingsTitle: 'Paramètres de notification',
    notificationSettingsDescription: 'Configurer comment vous voulez être notifié quand cette alerte se déclenche',
    alertSettingsTitle: 'Paramètres d\'alerte',
    alertSettingsDescription: 'Configurer les paramètres de temporisation et de répétition pour cette alerte',
    reviewTitle: 'Réviser la configuration de l\'alerte',
    reviewDescription: 'Veuillez réviser la configuration de votre alerte avant d\'enregistrer',
    
    // Étiquettes de champs
    field: 'Champ',
    operator: 'Opérateur',
    threshold: 'Seuil',
    sensors: 'Capteurs',
    emailAddresses: 'Adresses email',
    phoneNumbers: 'Numéros de téléphone',
    repeatMinutes: 'Répéter (minutes)',
    delayedNotificationMinutes: 'Notification différée (minutes)',
    
    // Options de champs
    temperature: 'Température',
    humidity: 'Humidité',
    
    // Opérateurs
    equals: '==',
    notEquals: '!=',
    greaterThan: '>',
    greaterThanOrEqual: '>=',
    lessThan: '<',
    lessThanOrEqual: '<=',
    
    // Notifications
    enableEmailNotifications: 'Activer les notifications par email',
    enableSmsNotifications: 'Activer les notifications SMS',
    pressEnterToAddEmail: 'Appuyez sur Entrée pour ajouter un email',
    pressEnterToAddPhone: 'Appuyez sur Entrée pour ajouter un numéro de téléphone',
    phonePlaceholder: '+1234567890',
    emailRecipientsLabel: 'Destinataires email',
    smsRecipientsLabel: 'Destinataires SMS',
    emailRecipientsHelper: 'Choisir dans l\'annuaire ou saisir un email puis Entrée',
    smsRecipientsHelper: 'Choisir dans l\'annuaire ou saisir un numéro puis Entrée',
    emailRecipientsPlaceholder: 'nom@exemple.com',
    smsRecipientsPlaceholder: '+33612345678',
    addressBookLoading: 'Chargement de l\'annuaire...',
    
    // Textes d\'aide
    repeatHelperText: 'À quelle fréquence répéter l\'alerte',
    delayHelperText: 'Délai avant la première notification',
    
    // Étiquettes de la section de révision
    basicInformationSection: 'Informations de base',
    alertConditionSection: 'Condition',
    alertConditionsSection: 'Conditions',
    sensorsSection: 'Capteurs',
    notificationsSection: 'Notifications',
    settingsSection: 'Paramètres',
    organizationLabel: 'Organisation :',
    alertNameLabel: 'Nom :',
    statusLabel: 'Statut :',
    repeatCountLabel: 'Nombre de répétitions :',
    delayedNotificationLabel: 'Notification différée :',
    emailNotificationsLabel: 'Notifications par email :',
    smsNotificationsLabel: 'Notifications SMS :',
    
    // Valeurs de statut
    statusEnabled: 'Activé',
    statusDisabled: 'Désactivé',
    notSelected: 'Non sélectionné',
    notSet: 'Non défini',
    noSensorsSelected: 'Aucun capteur sélectionné',
    noLocation: 'Aucun emplacement',
    fieldPlaceholder: 'champ',
    operatorPlaceholder: 'opérateur',
    thresholdPlaceholder: 'seuil',
    times: 'fois',
    minutes: 'minute(s)',
    
    // Description du déclencheur
    triggerWhen: 'Déclencher quand',
    triggerWhenAny: 'Déclencher si au moins une condition est vérifiée :',

    // Contrôles multi-conditions
    addCondition: 'Ajouter une condition',
    removeCondition: 'Retirer',
    conditionsLimitReached: (n: number) => `Maximum ${n} conditions atteint`
  },
  
  // Dialogue de mise à jour
  updateDialog: {
    title: 'Modifier l\'alerte',
    updating: 'Modification de l\'alerte...',
    success: 'Alerte modifiée avec succès'
  },

  // Textes du dialogue de confirmation de suppression
  deleteConfirmation: {
    title: 'Supprimer l\'alerte',
    message: 'Êtes-vous sûr de vouloir supprimer cette alerte ?',
    messageWithName: (name: string) => `Êtes-vous sûr de vouloir supprimer "${name}" ? Cette action ne peut pas être annulée.`,
    confirmButton: 'Supprimer',
    cancelButton: 'Annuler'
  },

  // Messages de succès
  messages: {
    createSuccess: 'Alerte créée avec succès',
    deleteSuccess: 'Alerte supprimée avec succès'
  },

  // Titres de la barre de notification
  snackbar: {
    successTitle: 'Succès',
    errorTitle: 'Erreur'
  },
  
  errors: {
    ALERT_NAME_REQUIRED: 'Le nom de l\'alerte est requis',
    ALERT_CONDITIONS_REQUIRED: 'Au moins une condition est requise',
    CONDITIONS_LIMIT_EXCEEDED: 'Limite de conditions dépassée',
    CONDITION_INVALID: 'Condition invalide',
    ALERT_SENSORS_REQUIRED: 'Au moins un capteur doit être sélectionné',
    ALERT_ID_REQUIRED: 'L\'ID de l\'alerte est requis',
    CONDITION_FIELD_REQUIRED: 'Le champ de condition est requis',
    CONDITION_OPERATOR_REQUIRED: 'L\'opérateur de condition est requis',
    CONDITION_THRESHOLD_REQUIRED: 'Le seuil de condition est requis',
    CONDITION_THRESHOLD_INVALID: 'Le seuil de condition doit être un nombre',
    CONDITION_OPERATOR_INVALID: 'Opérateur de condition invalide',
    EMAIL_ADDRESSES_REQUIRED: 'Au moins une adresse email est requise quand les notifications par email sont activées',
    EMAIL_FORMAT_INVALID: 'Format d\'adresse email invalide',
    PHONE_NUMBERS_REQUIRED: 'Au moins un numéro de téléphone est requis quand les notifications SMS sont activées',
    PHONE_FORMAT_INVALID: 'Format de numéro de téléphone invalide',
    EMAIL_RECIPIENTS_REQUIRED: 'Ajoutez au moins un destinataire email quand les notifications par email sont activées',
    SMS_RECIPIENTS_REQUIRED: 'Ajoutez au moins un destinataire SMS quand les notifications SMS sont activées',
    REPEAT_INTERVAL_INVALID: 'L\'intervalle de répétition ne peut pas être négatif',
    DELAYED_NOTIFICATION_INVALID: 'La notification différée ne peut pas être négative',
    CREATE_ALERT_FAILED: 'Échec de la création de l\'alerte',
    UPDATE_ALERT_FAILED: 'Échec de la modification de l\'alerte',
    DELETE_ALERT_FAILED: 'Échec de la suppression de l\'alerte'
  },

  // Textes du dialogue de document JSON de l'alerte
  documentDialog: {
    title: 'Document JSON de l\'alerte',
    alertLabel: 'Alerte :',
    description: 'Visualisation du document complet de l\'alerte en format JSON'
  }
} as const;